import * as React from 'react'
import { FunctionComponent, ReactElement } from 'react'
import { Route, Switch } from 'react-router'
import GlobalEmailOverview from './Email/GlobalEmailOverview'
import EmailOverview from './Email/EmailOverview'

type Props = {}

const Emails: FunctionComponent<Props> = (): ReactElement => {
    return (
        <Switch>
            <Route exact path="/email" component={GlobalEmailOverview} />
            <Route path="/file/:fileId/email" component={EmailOverview} />
        </Switch>
    )
}

export default Emails
